import PropTypes from "prop-types";
import React, { useEffect, useState } from "react"
import { Container, Card, Row, CardHeader, CardBody } from "reactstrap";


import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

import { withTranslation } from "react-i18next";
import * as url from "../../../src/helpers/url_helper";
import mammoth from 'mammoth';
// import { FaExpand, FaTimes } from 'react-icons/fa';
const Terms = props => {
  //meta title
  document.title = "Terms | ICE - Student Portal";

 
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch(url.BASE_URL + 'getTerms')
      .then(res => res.blob())
      .then(blob => blob.arrayBuffer())
      .then(arrayBuffer =>
        mammoth.convertToHtml({ arrayBuffer })
      )
      .then(result => {
        setContent(result.value); // result.value is HTML string
      })
      .catch(err => {
        console.error('Error reading .docx:', err);
      });
  }, []);




  return (
    <React.Fragment>
      <div className="page-content" style={{ position: 'relative' }}>
        <Container fluid>
       <Card style={{borderRadius:10}}> 
        <CardHeader className="bg-info" style={{color:'white', borderRadius:5}}><h5>Terms and condition</h5></CardHeader>
       <CardBody style={{ height:'85vh', overflow:'auto'}}>
      {/* <h2>Word Document Preview</h2> */}
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </CardBody>
       </Card>
       
       
        
        
        </Container>
      </div>
    </React.Fragment>
  );
};

Terms.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Terms);
